export default __webpack_public_path__ + "static/awarepath-_medium_2-4c78d011b0469ed60850b0df590152d9.png";